import { generate } from 'rxjs';
import { environment } from './../../environments/environment';
const domain = environment.apiDomain + '/api/';
const company = JSON.parse(localStorage.getItem('company'));

// export const GitToken = {
//   token: `VhuWqcBf5HZXLXnX2KV3`,
//   uiToken: `glpat-X3RjBzJotUq-qSHiJUf9`
// }
export const GitToken = {
  token: `glpat-cLy2cXH2iVsP2mxoK_kj`,
  uiToken: `glpat-X3RjBzJotUq-qSHiJUf9`,
};

export const Doctypes = {
  invoices: `Invoices`,
  lhdn: `LHDN Response`,
  excelUploadInvoices: `Excel upload Stats`,
  company: `company`,
  creditNotes: `Credit Note Items`,
  cancelledInvoices: `Cancelled Invoices Details`,
  gspApis: `GSP APIS`,
  sacCodes: `SAC HSN CODES`,
  paymentTypes: `Payment Types`,
  taxPayers: `TaxPayerDetail`,
  user: `User`,
  role: `Role`,
  report: `Report`,
  file: `File`,
  emailTemplates: `Email Template`,
  deleteDocument: `Deleted Document`,
  emailLogs: `Email Queue`,
  benchSettings: `Bench Settings`,
  benchMangerCmd: `Bench Manager Command`,
  updateLogs: `Update Logs`,
  socNotifications: `Socket Notification`,
  documentBin: `Document Bin`,
  emailQueue: `Email Queue`,
  emailDomain: `Email Domain`,
  emailAccount: `Email Account`,
  invoiceReconciliation: `Invoice Reconciliations`,
  irnObj: `IRN Objects`,
  errLogs: `Error Log`,
  posChecks: `POS Checks`,
  posPrinters: `POS Printers`,
  outlets: `Outlets`,
  posPrintSettings: `POS Print Settings`,
  tablet: `Active Tablets`,
  workStations: `Active Work Stations`,
  tabletConfig: `Tablet Config`,
  paymentRecon: `Invoice Payments`,
  information_invoice: `Information Invoices`,
  summaries: `Summaries`,
  events: `Events`,
  summaryPayments: `Summary Payments`,
  contacts: `Contacts`,
  TaxPayerDetail: `TaxPayerDetail`,
  TaxPayerDetails: `Taxpayer Details`,
  TaxPayerLocation: `Taxpayer Locations`,
  summaryDocuments: `Summary Documents`,
  documentTypes: `Document Types`,
  summaryContacts: `Summary Contacts`,
  items: `Items`,
  dispatchInfo: `Dispatch Details`,
  companyUserMap: `Company User Mapping`,
  userMap: `User Mapping`,
  gsps: `GSP API Details`,
  gstr2a: `GSTR 2A`,
  roles: `Role`,
  groups: `Company Groups`,
  gstrSavedData: `Gstr One Saved Details`,
  property: `Properties`,
  bankDetails: `Bank Details`,
  clbsSettings: `CLBS Settings`,
  summaryEmailTracking: `Summary Email Tracking`,
  reconDetails: `Recon Details`,
  userSignature: `User Signature`,
  syncLogs: `Sync Logs`,
  EzygstSettings: `EzyGST Settings`,
  syncConf: `Sync Configrations`,
  posChecksHistory: `POS Checks History`,
  checkDetails: `Check details`,
  PosChecksSettings: `POS Checks Settings`,
  TaxPayersAddresses: `Taxp Addresses`,
  VendorAddresses: `Vendor Address Details`,
  roles_permission: `Roles Permission`,
  Bulk_Irn_Statistics: `Bulk IRN Statistics`,
  locked_Details: `Locked Details`,
  taxilla_response_storage: `Taxilla Response Storage`,
  lhdl_settings: `MEI LHDN API Settings`,
  ar_accounts: `AR Accounts`,
  print_format: `Print Format`,
  vendor: `Vendor Details`,
  EInvoicerequests: 'E-Invoice Requests',
  lhdnInvoiceDetails: 'LHDN Invoice Details',
  mei_purchase: 'Mei Purchase Invoices',
  exchange_rates: `Ezyinvoice Currency Exchange`,
  b2g_address: `B2G Taxp Addresses`,
};

export const ApiUrls = {
  resource: domain + `resource`,
  getClient: domain + `method/frappe.client.get_value`,
  lhdnInvoiceDetails: domain + `resource/${Doctypes.lhdnInvoiceDetails}`,
  getCompanyList: domain + `method/frappe.desk.search.search_link`,
  login: domain + 'method/login',
  logout: domain + 'method/logout',
  company: domain + `resource/${Doctypes.company}`,
  exchange_rates: domain + `resource/${Doctypes.exchange_rates}`,
  emailQueue: domain + `resource/${Doctypes.emailQueue}`,
  EInvoicerequests: domain + `resource/${Doctypes.EInvoicerequests}`,
  purchases: domain + `resource/${Doctypes.mei_purchase}`,
  print_format: domain + `resource/${Doctypes.print_format}`,
  taxPayerAddress: domain + `resource/${Doctypes.TaxPayersAddresses}`,
  vendorAddress: domain + `resource/${Doctypes.VendorAddresses}`,
  creditNoteSummary: domain + `resource/${Doctypes.creditNotes}`,
  invoices: domain + `resource/${Doctypes.invoices}`,
  posChecks: domain + `resource/${Doctypes.posChecks}`,
  information_invoice: domain + `resource/${Doctypes.information_invoice}`,
  excelUploadInvoices: domain + `resource/${Doctypes.excelUploadInvoices}`,
  cancelledInvoiceDetails: domain + `resource/${Doctypes.cancelledInvoices}`,
  B2GAddress: domain + `resource/${Doctypes.b2g_address}`,
  taxilla_response_storage:
    domain + `resource/${Doctypes.taxilla_response_storage}`,
  lhdn_response_storage: domain + `resource/${Doctypes.lhdn}`,
  ar_accounts: domain + `resource/${Doctypes.ar_accounts}`,
  uploadFile: domain + `method/upload_file`,
  gspApis: domain + `resource/${Doctypes.gspApis}`,
  vendor: domain + `resource/${Doctypes.vendor}`,
  generateIrn: domain + `method/runserverobj`, // (403 err, replaced)
  // generateIrn: domain + `method/version2_app.version2_app.doctype.invoices.invoices.cancelIrn`,
  generateIrn_new:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.generateIrn`,
  bulk_generateIrn_new:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.bulk_generateIrn`,
  permanentInvoice: domain + `method/frappe.client.submit`,
  frappeCancelIrn: domain + `method/frappe.desk.form.save.cancel`,
  amendDoc: domain + `method/frappe.client.is_document_amended`,
  taxPayers:
    domain +
    `method/version2_app.version2_app.doctype.tax_payer_details.tax_payer_details.getTaxPayerDetails`,
  taxPayersDetails:
    domain +
    `method/version2_app.version2_app.doctype.tax_payer_details.tax_payer_details.TaxPayerDetails`,
  dashboard:
    domain + `method/frappe.desk.doctype.dashboard_chart.dashboard_chart.get`,
  sacHsn: domain + `resource/${Doctypes.sacCodes}`,
  paymentTypes: domain + `resource/${Doctypes.paymentTypes}`,
  taxPayerDefault: domain + `resource/${Doctypes.taxPayers}`,
  reinitiate: domain + `method/version2_app.parsers.`,
  new_reinitiate:
    domain + `method/version2_app.parsers_invoice.invoice_parsers.`,
  uaeReadInvoicePdf:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoice_parser.read_invoice_pdf`,
  // reinitiate: domain + `method/version2_app.version2_app.doctype.invoices.reinitiate_parser.reinitiateInvoice`,
  permissions: domain + `method/frappe.desk.form.load.getdoc`,
  perDoctype: domain + `method/frappe.desk.form.load.getdoctype`,
  userRoles:
    domain +
    `method/version2_app.version2_app.doctype.company.company.getUserRoles`,
  users: domain + `resource/${Doctypes.user}`,
  roles: domain + `resource/${Doctypes.role}`,
  errorLog: domain + `resource/${Doctypes.errLogs}`,
  rolePermissions:
    domain + `method/frappe.core.doctype.user.user.get_perm_info`,
  roleByUser: domain + `method/frappe.desk.reportview.get`,
  sacSummaries:
    domain +
    `method/version2_app.version2_app.doctype.getHsn_sac_code.getTotalamount`,
  creditSummaries:
    domain +
    `method/version2_app.version2_app.doctype.getCreditnote.getCreditnote`,
  reports: domain + `method/frappe.desk.query_report.run`,
  exportReports:
    domain + `method/frappe.core.doctype.access_log.access_log.make_access_log`,
  reportMethod:
    domain +
    `method/version2_app.version2_app.doctype.company.reportsDownload.Report_Download`,
  reportList: domain + `resource/${Doctypes.report}`,
  deleteReportFile:
    domain +
    `method/version2_app.version2_app.doctype.company.reportsDownload.Report_Delete`,
  getEmailTemplates: domain + `method/frappe.desk.search.search_link`,
  getEmailTempData:
    domain +
    `method/frappe.email.doctype.email_template.email_template.get_email_template`,
  sendEmail: domain + `method/frappe.core.doctype.communication.email.make`,
  filesPath: domain + `resource/${Doctypes.file}`,
  fileSave: domain + `method/frappe.desk.form.save.savedocs`,
  changePassword:
    domain + `method/frappe.core.doctype.user.user.reset_password?user=`,
  networkStatus:
    domain +
    `method/version2_app.version2_app.doctype.company.checkInternet.CheckInternetConnection`,
  emailTemplates:
    domain +
    `method/version2_app.version2_app.doctype.emailTemplat.emailTemplate`,
  getPrinters:
    domain +
    `method/version2_app.version2_app.doctype.company.company.getPrinters`,
  print:
    domain +
    `method/version2_app.version2_app.doctype.company.company.givePrint`,
  benchUpdate:
    domain +
    `method/version2_app.version2_app.doctype.company.company.console_command`,
  // benchUpdate_new: domain + `method/version2_app.version2_app.doctype.company.company.gitpull`,
  customEmailTemplates:
    domain +
    `method/frappe.printing.doctype.print_settings.print_settings.is_print_server_enabled`,
  addUserRoles:
    domain +
    `method/version2_app.version2_app.doctype.getUserRoles.getUserRoles`,
  reAttach:
    domain +
    `method/version2_app.version2_app.doctype.invoices.attach_qr_code.AttachQrCodeInInvoice`,
  generateQR:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.send_invoicedata_to_gcb`,
  // checkUpdates: domain + `method/version2_app.version2_app.doctype.company.company.gitCurrentBranchCommit`,
  tempLineItemEdit:
    domain +
    `method/version2_app.version2_app.doctype.invoices.reinitate_invoice.reprocess_calulate_items`,
  manualCreditNotes:
    domain +
    `method/version2_app.verssion2_app.doctype.invoices.credit_manual_invoice.CreditManualInvoice`,
  // creditInvoice: domain + `resource/Invoices`,
  cal_items:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.calulate_items`,
  sac_items:
    domain +
    `method/version2_app.version2_app.doctype.invoices.reinitate_invoice.Reinitiate_invoice`,
  redo_err_invoices:
    domain +
    `method/version2_app.version2_app.doctype.company.company.reprocess_error_inoices`,
  file_parser:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoice_parser.file_parsing`,
  emailSend:
    domain + `method/version2_app.version2_app.doctype.company.company.make`,
  gspToken:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.updatelogin_gsp`,
  covertToCredit:
    domain +
    `method/version2_app.version2_app.doctype.invoices.manual_tax_invoice.Convert_to_manual_tax_invoice`,
  restoreFile:
    domain +
    `method/frappe.core.doctype.deleted_document.deleted_document.restore`,
  xlBulkInvoice:
    domain +
    `method/version2_app.version2_app.doctype.invoices.manual_upload.manual_upload`,
  sendEmailQueue:
    domain + `method/frappe.email.doctype.email_queue.email_queue.send_now`,
  deleteInvoices: domain + `method/frappe.desk.reportview.delete_items`,
  migrateBench:
    domain +
    `method/version2_app.version2_app.doctype.company.company.bench_migrate`,
  getErrInvoices:
    domain +
    `method/version2_app.version2_app.doctype.company.company.errorInvoicesList`,
  clearNotifications:
    domain +
    `method/version2_app.version2_app.doctype.socket_notification.socket_notification.DeleteNotifications`,
  parserFile:
    domain +
    `method/version2_app.version2_app.doctype.company.get_parsers_file_path.get_parser_filePath`,
  Uiupdate:
    domain +
    `method/version2_app.version2_app.doctype.company.company.updateUiProd`,
  // uiUpdateGitCommit: domain + `method/version2_app.version2_app.doctype.company.company.gitUiBranchCommit`,
  updateParsers:
    domain +
    `method/version2_app.version2_app.doctype.company.company.update_parsers`,
  checkProxy:
    domain +
    `method/version2_app.version2_app.doctype.company.company.updateProxySettings`,
  reprocessBulkUpload:
    domain +
    `method/version2_app.version2_app.doctype.invoices.bulk_upload_reprocess.BulkUploadReprocess`,
  reconcilationCount:
    domain +
    `method/version2_app.version2_app.doctype.invoice_reconciliations.invoice_reconciliations.invoicereconciliationcount`,
  mei_reconcilationCount:
    domain +
    `method/version2_app.version2_app.doctype.invoice_reconciliations.invoice_reconciliations.mei_invoicereconciliationcount`,
  pendingIrnObj:
    domain +
    `method/version2_app.version2_app.doctype.irn_objects.irn_objects.IrnObject`,
  diskSpace:
    domain +
    `method/version2_app.version2_app.doctype.company.company.diskspace`,
  totalCount:
    domain +
    `method/version2_app.version2_app.doctype.dashboard_apis.invoicecategorycount`,
  invoiceDetailsCount:
    domain +
    `method/version2_app.version2_app.doctype.dashboard_apis.invoicedetailscount`,
  gstrStatistics:
    domain +
    `method/version2_app.version2_app.doctype.dashboard_apis.GSTR1Statistics`,
  invoiceReconsiliationCount:
    domain +
    `method/version2_app.version2_app.doctype.dashboard_apis.invoicereconsiliationcount`,
  reprocessDocmentBin:
    domain +
    `method/version2_app.version2_app.doctype.company.company.reprocess_error_documentbin_invoices`,
  bulkUploadHolidayEx:
    domain +
    `method/version2_app.version2_app.doctype.invoices.holiday_manual_upload.holidayinManualupload`,
  gspMetering:
    domain +
    `method/version2_app.version2_app.doctype.gsp_metering.gsp_metering.gspmeteringdata`,
  autoAdjustment:
    domain +
    `method/version2_app.version2_app.doctype.invoices.reinitate_invoice.auto_adjustment`,
  reconcilation:
    domain + `method/version2_app.version2_app.doctype.xml_parse.extract_xml`,
  convertToCreditNote:
    domain +
    `method/version2_app.version2_app.doctype.invoices.reinitate_invoice.b2b_success_to_credit_note`,
  raise_credit_taxinvoice:
    domain +
    `method/version2_app.version2_app.doctype.invoices.reinitate_invoice.raise_credit_taxinvoice`,
  posPrinterSettings:
    domain +
    `method/version2_app.pos_bills.doctype.pos_print_settings.pos_print_settings.pos_printer_settings`,
  posPrintBill:
    domain +
    `method/version2_app.pos_bills.doctype.pos_checks.pos_checks.print_pos_bill`,
  tabletReset:
    domain +
    `method/version2_app.sign_ezy.doctype.active_tablets.active_tablets.resetworkstation_tablet`,
  dowloadGSTR1:
    domain +
    `method/version2_app.version2_app.doctype.company.reportsDownload.gstr1_excel_workbook`,
  updateGSTRDetails:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.get_taxpayerdetails`,
  get_tax_payer_details:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.get_tax_payer_details`,
  diagnostic:
    domain + `method/version2_app.events.backup_file_perticulerdoctypes`,
  createBreakUp:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.create_summary_breakup`,
  getBreakup:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.get_summary_breakup`,
  download_pdf:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.download_pdf`,
  contacts: domain + `resource/${Doctypes.contacts}`,
  taxpayerdetails: domain + `resource/${Doctypes.TaxPayerDetail}`,
  taxpayerlocation: domain + `resource/${Doctypes.TaxPayerLocation}`,
  posChecksHistory: domain + `resource/${Doctypes.posChecksHistory}`,
  pincodeApi: `https://api.postalpincode.in/pincode/`,
  deleteInvoiceFrmSmry:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.delete_invoice_summary_breakup`,
  guest_details_encrypted:
    domain +
    `method/version2_app.version2_app.doctype.invoices.encrypt_details_of_guest.guest_details_encrypted`,
  updateSummary:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.update_summary_breakup`,
  printFromatsClbs:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.summary_print_formats`,
  summaryPdfFiles:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.download_pdf`,
  updateSummaryData:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.update_summary`,
  submitSummary:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.submit_summary`,
  sendEmailSummary:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.send_summary_mail`,
  version: `${domain}resource/Version`,
  summaryActivityLog:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.get_summaries_activity_log`,
  delete_summary:
    domain +
    `method/version2_app.clbs.doctype.summaries.summaries.delete_summaries`,
  //gstr Api's
  gstr2Excel: `${domain}method/gstr2_filing.gstr2_filing.doctype.gstr_2a.gstr_2a.gstr2a_excel`,
  gstr2ATheads: `${domain}method/gstr2_filing.gstr2_filing.doctype.gstr_2a.gstr_2a.get_gstr2a_names`,
  gstr2AMapped: `${domain}method/gstr2_filing.gstr2_filing.doctype.gstr_2a.gstr_2a.gstr2a_data_upload`,
  // addUserRoles: domain + `method/ezy_gst.ezy_gst.doctype.getUserRoles.getUserRoles`,
  gstr2Ab2bData:
    domain +
    `method/gstr2_filing.gstr2_filing.doctype.gstr_2a.gstr_2a.gstr2a_filter_totalamountsums`,
  getInvoices:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.getInvoices`,
  userMapping:
    domain +
    `method/ezy_gst.ezy_gst.doctype.user_mapping.user_mapping.getUsers`,
  userPropertyMapping:
    domain +
    `method/ezy_gst.ezy_gst.doctype.user_mapping.user_mapping.create_update_user_mapping`,
  getUserMapping:
    domain +
    `method/ezy_gst.ezy_gst.doctype.user_mapping.user_mapping.get_user_mapping_details`,
  retSave:
    domain +
    `method/ezy_gst.ezy_gst.doctype.gsp_util_module.gstr_1_b2b_retsave.retsave_b2b`,
  retSubmit:
    domain +
    `method/ezy_gst.ezy_gst.doctype.gsp_util_module.gstr_1_b2b_retsave.ret_save_submit_with_otp`,
  reconcile:
    domain +
    `method/ezy_gst.ezy_gst.doctype.gsp_util_module.get_gstr_1_invoices.get_gst_saved_invoices`,
  dashboardGSTR1:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.getGSTR1DashboardDetails`,
  sacHsnSummary:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.getHsnSummary`,
  reconcileSummary:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.getGSTR1ReconciliationSummaryCount`,
  summary_activity_log:
    domain +
    `method/version2_app.clbs.doctype.summaries.summaries.summary_activity_log`,
  email_tracking: domain + `resource/${Doctypes.summaryEmailTracking}`,
  export_gstr1_invoices:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.export_invoices`,
  nill_rated_supplies:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.nil_rated_supplies`,
  export_workbook:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.export_workbook`,
  clbsSettings: domain + `resource/${Doctypes.clbsSettings}`,
  nill_rated_items:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.nill_rated_items`,
  document_series:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.document_sequence`,
  reconciliation:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.reconciliation`,
  workbook_export:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.export_workbook_recon`,
  create_reconciliation:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.create_reconciliation`,
  export_recon:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.export_recon`,
  delete_recon:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.delete_recon_file`,
  redo_recon:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.Redo_recon`,
  invoice_recon_dashboard:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.dashborad_recon`,
  invoice_recon_last_updated:
    domain +
    `method/version2_app.version2_app.doctype.invoices.ezy_gst_dashboard.last_recon_update`,
  exportInvoiceLineItems:
    domain +
    `method/version2_app.version2_app.doctype.items.items.invoice_items`,
  getItemsForPosChecks:
    domain +
    `method/version2_app.version2_app.doctype.items.items.get_items_for_pos_checks`,
  updateCheckInItems:
    domain +
    `method/version2_app.pos_bills.doctype.pos_checks.pos_checks.update_check_in_items`,
  getPosChecksData:
    domain +
    `method/version2_app.pos_bills.doctype.pos_checks.pos_checks.get_pos_checks_clbs`,
  summary_amendment:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.summary_amendment`,
  update_document_sequence:
    domain +
    `method/version2_app.clbs.doctype.document_types.document_types.update_document_sequence`,
  user_name_rename_doc: domain + `method/frappe.rename_doc`,
  e_signature:
    domain +
    `method/version2_app.e_signature.e_signature.add_esignature_to_invoice`,
  add_signature_on_etax:
    domain +
    `method/version2_app.e_signature.e_signature.add_signature_on_etax`,
  get_amendments:
    domain +
    `method/invoice_sync.invoice_sync.report.amendment.amendment.get_amendments`,
  getSync: domain + `method/frappe.desk.form.load.getdoc`,
  syncLogs: domain + `resource/${Doctypes.syncLogs}`,
  // syncLogs: domain + `resource/get_sync_logs`,
  syncLogsDashboard:
    domain +
    `method/invoice_sync.sync_dashboard_history.get_total_dashboard_count_sync_history`,
  // sync_data_from_web_dashboard: domain + `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.sync_data_from_web`,

  sync_data_from_web:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.sync_invoices_bulk`,

  sync_data_to_erp_single:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.sync_data_to_erp_single`,
  sync_data_to_erp:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.sync_data_to_erp`,
  manual_sync_taxpayer_details:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.manual_sync_taxpayer_details`,
  manual_sync_items:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.manual_sync_items`,
  EzygstSettings: domain + `resource/${Doctypes.EzygstSettings}`,
  get_data_amendment_sac_hsn_summary:
    domain +
    `method/invoice_sync.invoice_sync.report.amendment_sac_hsn_summary.amendment_sac_hsn_summary.get_data`,
  bulk_sync_ezygst:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.bulk_sync_ezygst`,
  accept_amendments:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.accept_amendments`,
  missing_irn_generation:
    domain +
    `method/version2_app.version2_app.doctype.invoices.e_invoice_missing_count.get_missing_count`,
  validate_irn_gen_date:
    domain +
    `method/version2_app.version2_app.doctype.invoices.e_invoice_missing_count.check_invoice_date_if_graterthan_days`,
  report_for_invoices:
    domain +
    `method/version2_app.version2_app.doctype.invoices.e_invoice_missing_count.download_due_and_expired_reports`,
  reprocess_B2C_pending_invoices:
    domain +
    `method/version2_app.version2_app.doctype.company.company.reprocess_B2C_pending_invoices`,
  reSync_based_on_from_to_dates:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.desync_invoices`,
  export_as_excel_errorlogs:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.export_error_sync_logs`,
  redo_error:
    domain +
    `method/version2_app.version2_app.doctype.company.company.reprocess_error_documentbin_invoices?docdate=2023-07-12`,
  sac_code_details:
    domain +
    `method/version2_app.version2_app.download_taxpayer_details.get_all_sac_code_details`,
  payment_details:
    domain +
    `method/version2_app.version2_app.download_taxpayer_details.get_all_payment_details`,
  tax_payer_details:
    domain +
    `method/version2_app.version2_app.download_taxpayer_details.get_all_taxpayer_details`,
  update_signature_on_pdf:
    domain +
    `method/version2_app.e_signature.e_signature.after_add_signature_for_existing_invoices`,
  download_etax_with_gst_no: domain + `method/version2_app.events.html_to_pdf`,
  syncdashboard_invoice_count:
    domain +
    `method/version2_app.version2_app.doctype.dashboard_apis.invoicedetailscount`,
  getExactTotalInvoiceData:
    domain +
    `method/version2_app.version2_app.doctype.dashboard_apis.get_total_dashboard_count_ezyinvoicing`,
  mei_overall_invoice_dashboard:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_dashboard.mei_overall_invoice_dashboard`,
  download_poschecks:
    domain +
    `method/version2_app.pos_bills.doctype.pos_checks.pos_checks.pos_to_pdf`,
  amendedResync:
    domain +
    `method/invoice_sync.invoice_sync.doctype.amendments_sync.amendments_resync`,
  download_etaxinvoice:
    domain + `method/version2_app.events.download_etaxinvoice`,

  // reSyncInvoice: domain + `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.upload_template`,
  users_by_roles:
    domain +
    `method/version2_app.version2_app.doctype.routes.routes.user_by_roles_companies`,
  roles_permission: domain + `resource/${Doctypes.roles_permission}`,
  reset_password:
    domain +
    `method/version2_app.version2_app.doctype.routes.routes.reset_initial_password`,
  check_old_password:
    domain +
    `method/version2_app.version2_app.doctype.routes.routes.change_old_password`,
  initial_password:
    domain +
    `method/version2_app.version2_app.doctype.routes.routes.update_pwd`,
  logout_custom:
    domain +
    `method/version2_app.version2_app.doctype.permission_list.permission_list.logout_user`,
  // download_etax_with_gst_no:domain+`method/version2_app.events.html_to_pdf`

  reSyncInvoice:
    domain +
    `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.sync_invoices_based_on_return_period`,
  exportDifferenceInvoices:
    domain + `method/invoice_sync.sync_dashboard_history.difference_invoice`,
  UpdateAddress:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.change_manual_address`,
  set_as_default:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.set_default_address`,
  // reSyncInvoice: domain + `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.sync_invoices_based_on_return_period`,
  // reSyncInvoice: domain + `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.sync_invoices_based_on_return_period`,
  reProcessChecks: domain + `method/version2_app.events.reprocess_pos_check`,
  reconcilling_check_details:
    domain +
    `method/version2_app.pos_bills.doctype.check_details.check_details.reconcilling_check_details`,
  transaction_summary_extraction:
    domain +
    `method/version2_app.pos_bills.doctype.transaction_summary.transaction_summary.transaction_summary_extraction`,
  print_ent_format:
    domain +
    `method/version2_app.pos_bills.doctype.check_details.check_details.print_ent_format`,
  print_formt_void_check:
    domain +
    `method/version2_app.pos_bills.doctype.check_details.check_details.print_formt_void_check`,
  print_discount_format:
    domain +
    `method/version2_app.pos_bills.doctype.check_details.check_details.print_discount_format`,
  pos_reports_export:
    domain +
    `method/version2_app.pos_bills.doctype.check_details.check_details.export_pos_reports`,
  closed_file_extraction:
    domain +
    `method/version2_app.pos_bills.doctype.closed_checks.closed_checks.closed_file_extraction`,
  void_file_extraction:
    domain +
    `method/version2_app.pos_bills.doctype.void_checks.void_checks.void_file_extraction`,
  discount_file_extraction:
    domain +
    `method/version2_app.pos_bills.doctype.discount_checks.discount_checks.discount_file_extraction`,
  addNewGst:
    domain +
    `method/version2_app.version2_app.doctype.tax_payer_details.tax_payer_details.update_addresse_in_taxpAdd`,
  // reSyncInvoice: domain + `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.upload_template`,
  // reSyncInvoice: domain + `method/invoice_sync.invoice_sync.doctype.sync_logs.sync_logs.sync_invoices_based_on_return_period`,
  // exportDifferenceInvoices:domain+`method/invoice_sync.sync_dashboard_history.difference_invoice`,
  autosyncdash:
    domain +
    `method/invoice_sync.sync_dashboard_history.sync_dashboard_enqueue`,

  disable_role_if_user_not_assigned:
    domain +
    `method/version2_app.version2_app.doctype.permission_list.permission_list.disable_role_if_user_not_assigned`,
  getting_auth_url: domain + `method/version2_app.utils.getting_auth_url`,
  lockmechanism_sync_history:
    domain +
    `method/invoice_sync.invoice_sync.doctype.locked_details.locked_details.update_locked`,
  locked_Details: domain + `resource/${Doctypes.locked_Details}`,
  duplicatePosChecks:
    domain +
    `method/version2_app.pos_bills.doctype.pos_checks.pos_checks.adding_duplicate_checks`,
  summaryExcelExport:
    domain +
    `method/version2_app.clbs.doctype.summary_breakups.summary_breakups.summary_xlsx_format`,

  posting_invoice_taxilla:
    domain +
    `method/mei.mei_core.doctype.mei_lhdn_api_settings.e_inv_api_calls.asynchronous_invoice_submission`,
  immediate_response_for_submission_to_lhdn:
    domain +
    `method/mei.mei_core.doctype.mei_lhdn_api_settings.e_inv_api_calls.immediate_response_for_submission_to_lhdn`,
  uae_uuid_generation:
    domain +
    `method/version2_app.version2_app.doctype.invoices.uae_invoice_submissions.uae_uuid_generation`,
  exec_in_progress_near_lhdn:
    domain +
    `method/mei.mei_core.doctype.mei_lhdn_api_settings.e_inv_api_calls.exec_in_progress_near_lhdn`,
  getting_invoice_status_taxilla:
    domain +
    `method/mei.mei_core.doctype.mei_lhdn_api_settings.e_inv_api_calls.get_submission`,
  // cancel_invoice_taxila:
  //   domain +
  //   `method/version2_app.version2_app.doctype.invoices.mei_invoice_formatting.cancel_invoice_taxila`,
  cancel_invoice_taxila:
    domain +
    'method/mei.mei_core.doctype.mei_lhdn_api_settings.e_inv_api_calls.cancel_document',
  mei_reprocess_calculate_items:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_calculations.mei_reprocess_calculate_items`,
  mei_calculations:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_calculations.mei_calculations`,
  mei_b2b_success_to_credit_note:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_calculations.mei_b2b_success_to_credit_note`,
  start_consolidation:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_b2c_consolidation.mei_b2c_consolidation`,
  getB2cMiniDashboardCount:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_b2c_consolidation.mei_invoice_count`,
  generateB2cUUID:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_invoice_formatting.post_b2c_consolidated_invoice_taxilla`,
  getB2cUUIDStatus:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_invoice_formatting.getting_consolidated_invoice_status_taxilla`,
  invoice_pdf_to_base64:
    domain + `method/version2_app.new_events.invoice_pdf_to_base64`,
  mei_b2c_regular_consolidation:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_b2c_consolidation.mei_b2c_regular_consolidation`,
  mei_b2c_monthly_data:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_b2c_consolidation.mei_b2c_monthly_data`,
  mei_todo_invoice_count:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_dashboard.mei_todo_invoice_count`,
  get_todo_invoices:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.get_todo_invoices`,
  getArAccounts:
    domain +
    `method/version2_app.version2_app.doctype.ar_accounts.ar_accounts.ar_accounts_data`,

  tin_validation:
    domain +
    `method/mei.mei_core.doctype.mei_lhdn_api_settings.e_inv_api_calls.tin_validation`,
  view_ar_invoicesDashboard:
    domain +
    `method/version2_app.version2_app.doctype.ar_accounts.ar_accounts.ar_accounts_mini_dashboard`,
  arAddTin:
    domain +
    'method/version2_app.version2_app.doctype.invoices.mei_b2c_consolidation.mei_adding_tin',
  lhdl_settings: domain + `resource/${Doctypes.lhdl_settings}`,
  backgroud_bulk_invoices_reprocess:
    domain +
    `method/version2_app.version2_app.doctype.invoices.bulk_upload_reprocess.backgroud_bulk_invoices_reprocess`,

  upload_ar_master_data:
    domain +
    `method/version2_app.version2_app.doctype.ar_accounts.ar_accounts.uploaidng_ar_master_data`,
  simpleReconInnerTable:
    domain +
    `method/version2_app.version2_app.doctype.invoice_reconciliations.invoice_reconciliations.mei_simple_recon_invoice_wise`,
  invoiceReconciliation:
    domain + `method/version2_app.version2_app.doctype.xml_parse.extract_xml`,
  update_monthly_wise_simple_recon:
    domain +
    `method/version2_app.version2_app.doctype.invoice_reconciliations.invoice_reconciliations.update_monthly_wise_simple_recon`,
  health_dashboard:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_dashboard.mei_health_dashboard`,
  b2c_consolidation_chart_data:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_dashboard.mei_health_dashboard_consolidation`,
  todo_dashboard:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_dashboard.mei_overall_invoice_info`,
  deleteTaxPayer:
    domain +
    `method/version2_app.version2_app.doctype.tax_payer_details.tax_payer_details.remove_tax_payer_detail`,
  mei_pos_checks_creation:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_pos_checks.mei_pos_checks_creation`,
  // update_monthly_wise_simple_recon: domain + `method/version2_app.version2_app.doctype.invoice_reconciliations.invoice_reconciliations.update_monthly_wise_simple_recon`,
  get_taxpayer_details:
    domain +
    `method/version2_app.version2_app.doctype.tax_payer_details.tax_payer_details.get_taxpayer_details`,
  group_invoices:
    domain +
    `method/version2_app.version2_app.doctype.invoices.group_invoices.group_invoices`,
  upload_invoice:
    domain +
    `method/version2_app.version2_app.doctype.excel_upload_stats.excel_upload_stats.upload_invoice_data`,
  lhdn_export_invoice:
    domain +
    `method/version2_app.version2_app.doctype.lhdn_invoice_details.lhdn_invoice_details.lhdn_invoice_data_and_invoices`,
  revenue_reconciliation:
    domain +
    `method/version2_app.version2_app.doctype.invoice_reconciliations.invoice_reconciliations.mei_revenue_reconcillation`,
  view_revenue_recon:
    domain +
    `method/version2_app.version2_app.doctype.invoice_reconciliations.invoice_reconciliations.mei_revenue_reconcillation_day_wise`,
  exportRevenueReport:
    domain +
    `method/version2_app.version2_app.doctype.invoice_reconciliations.invoice_reconciliations.mei_revenue_wise_data`,
  update_ignore_button:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.update_ignore_button`,
  b2cttxEmail: domain + `method/version2_app.new_events.send_b2c_ttx_mails`,
  duplicate_invoice_accept:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.duplicate_invoice_status`,
  get_id: domain + `method/version2_app.jwt_token.get_id`,
  exportB2cConsolidation:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_b2c_consolidation.b2c_consolidated_report`,
  // fetchLhdn:
  //   domain +
  //   `/method/version2_app.version2_app.doctype.lhdn_invoice_details.lhdn_invoice_details.enqueue_fetch_lhdn_data`,
  fetchLhdn:
    domain +
    `method/version2_app.version2_app.doctype.lhdn_invoice_details.lhdn_invoice_details.receiving_lhdn_data`,
  purchase_import:
    domain +
    `method/version2_app.version2_app.doctype.mei_purchase_invoices.mei_purchase_invoices.get_mei_purchase_invoice_data`,
  purchase_file_import:
    domain +
    `method/version2_app.version2_app.doctype.mei_purchase_invoices.mei_purchase_invoices.enqueue_purchase_invoice_upload`,
  allB2cInvoices:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_b2c_consolidation.b2c_consolidation_all_b2c_invoices`,

  todoMissingExpenseItems:
    domain +
    `method/version2_app.version2_app.doctype.mei_purchase_invoices.mei_purchase_invoices.new_expense_item_list`,
  finalizePR:
    domain +
    `method/version2_app.version2_app.doctype.mei_purchase_invoices.mei_purchase_invoices.enqueue_self_billed_invoice_creation`,
  updateAllExpenseItems:
    domain +
    'method/version2_app.version2_app.doctype.sac_hsn_codes.sac_hsn_codes.bulk_update_expense_items',
  purchase_invoice_info:
    domain +
    `method/version2_app.version2_app.doctype.mei_purchase_invoices.mei_purchase_invoices.mei_purchase_invoice_view`,
  getVendorDetails:
    domain +
    `method/version2_app.version2_app.doctype.vendor_details.vendor_details.get_vendor_details`,
  getAllExpenseItems:
    domain +
    `method/version2_app.version2_app.doctype.sac_hsn_codes.sac_hsn_codes.new_expense_items_data`,
  getAllPosChecksData:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_pos_checks.pos_checks_from_invoices`,
  getInvoiceCheckData:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_pos_checks.check_preview`,
  createGroupedInvoice:
    domain +
    `method/version2_app.version2_app.doctype.invoices.group_invoices.create_group_invoice`,
  get_transfer_amount:
    domain +
    `method/version2_app.version2_app.doctype.invoices.group_invoices.get_transfer_amount`,
  grouped_inv_mark_as_paid_and_ignore:
    domain +
    `method/version2_app.version2_app.doctype.invoices.group_invoices.update_ignore_paid_invoices`,
  deletePRInvs:
    domain +
    `method/version2_app.version2_app.doctype.mei_purchase_invoices.mei_purchase_invoices.create_self_billed_invoices`,
  deleteSalesInvs:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.bulk_delete_invoices`,
  updateReasonRM:
    domain +
    `method/version2_app.version2_app.doctype.invoices.mei_pos_checks.ten_thousand_rm_reason_update`,
  updateCountryState:
    domain +
    `method/version2_app.version2_app.doctype.invoices.invoices.update_country_state`,
};
